<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue'
import { PRODUCT_NAME } from '@bf/domain'
import AppShell from './components/AppShell.vue'
import { useShowroomStore } from './store/showroom'

const store = useShowroomStore()
let refreshTimer: number | undefined

function refreshWhenVisible() {
  if (document.visibilityState === 'visible') void store.load(true)
}

onMounted(() => {
  void store.load()
  refreshTimer = window.setInterval(refreshWhenVisible, 30_000)
  document.addEventListener('visibilitychange', refreshWhenVisible)
})

onBeforeUnmount(() => {
  if (refreshTimer !== undefined) window.clearInterval(refreshTimer)
  document.removeEventListener('visibilitychange', refreshWhenVisible)
})
</script>

<template>
  <div v-if="store.state.loading" class="startup-screen" role="status">
    <div class="startup-mark" aria-hidden="true">BF</div>
    <p>正在准备{{ PRODUCT_NAME }}…</p>
  </div>

  <div v-else-if="store.state.error" class="startup-screen startup-error">
    <div class="startup-mark startup-mark-error" aria-hidden="true">!</div>
    <h1>展厅暂时无法启动</h1>
    <p>{{ store.state.error }}</p>
    <button class="button button-primary" type="button" @click="store.load()">
      重新检查
    </button>
  </div>

  <AppShell v-else />
</template>
